import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from '@mui/icons-material/GetApp';

import UserService from "services/UserService";
import axios from "axios";
import { getMBMEquipments } from "services/ConfigServices";
import { equipmenttext, equipmentpagetext, pointtext } from "variables/MBM/equipments";
import { definitionData, fieldprotocoleData, eosprotocoleData, displaymethodData, hardwareData } from "variables/MBM/lists/equipments";
import { dico } from "variables/lists/dico";
import moment from "moment";
import CustomSelect from "components/Input/CustomSelect.js";
import { downloadCSV } from "utilities/exporttabletocsv";
import Button from "components/CustomButtons/Button.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const FilterDiv = styled.div`
  margin-right: auto;
  margin-top: -8px;
`;


export default function useEquipmentsTable(wpgroup, workspace, iotdata, alarmsdata) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbmadmin = permis.includes("mbm_admin");
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMBMEquipments(wpgroup, 'false', 'false', workspace.id);
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [equipmentsdata, setEquipmentsData] = useState([]);
  const [pointsdata, setPointsData] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [points, setPoints] = useState([]);
  const [displaymethod, setDisplaymethod] = useState("equipments");

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (wpgroup && wpgroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === wpgroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setEquipmentsData(response.data.equipments);
        setPointsData(response.data.points);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = wpgroup;
      fetchData();
    }
  }, [wpgroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const handleDisplaymethodChange = (event) => { setDisplaymethod(event.target.value); };

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  // const filteredItems = displaymethod === 'equipments' ? _.get(results, `equipments`, []).filter(
  //   (item) =>
  //     (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
  //     (item.definition && definitionData.find((x) => x.id == item.definition) && definitionData.find((x) => x.id == item.definition).name.toLowerCase().includes(filterText.toLowerCase())) ||
  //     (item.groupid && groupInfoListById["" + item.groupid] && groupInfoListById["" + item.groupid].toLowerCase().includes(filterText.toLowerCase())) ||
  //     (item.connectionproperties?.eosprotocol && eosprotocoleData.find((x) => x.id == item.connectionproperties.eosprotocol) && eosprotocoleData.find((x) => x.id == item.connectionproperties.eosprotocol).name.toLowerCase().includes(filterText.toLowerCase()))
  //       (item.connectionproperties?.fieldProtocol && fieldprotocoleData.find((x) => x.id == item.connectionproperties.fieldProtocol) && fieldprotocoleData.find((x) => x.id == item.connectionproperties.fieldProtocol).name.toLowerCase().includes(filterText.toLowerCase()))
  // ) : _.get(results, `points`, []).filter(
  //   (item) =>
  //     (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
  //     (item.definition && dico.find((x) => x.id == item.definition) && dico.find((x) => x.id == item.definition).name.toLowerCase().includes(filterText.toLowerCase())) ||
  //     (item.state && stateData.find((x) => x.id == item.state) && stateData.find((x) => x.id == item.state).name.toLowerCase().includes(filterText.toLowerCase())) ||
  //     (item.equipment && equipmentsdata.find((x) => x.id == item.equipment) && equipmentsdata.find((x) => x.id == item.equipment).name.toLowerCase().includes(filterText.toLowerCase())) ||
  //     (item.unit && dico.find((x) => x.id == item.definition) && dico.find((x) => x.id == item.definition).unit.toLowerCase().includes(filterText.toLowerCase())) ||
  //     (item.groupid && groupInfoListById["" + item.groupid] && groupInfoListById["" + item.groupid].toLowerCase().includes(filterText.toLowerCase())) ||
  //     (item.lastdate && moment(item.lastdate).isValid() && moment(item.lastdate).format("DD/MM/YYYY HH:mm").includes(filterText))
  // )
  // ;

  const filteredItemsEquipments = _.get(results, `equipments`, []).filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.definition && definitionData.find((x) => x.id == item.definition) && definitionData.find((x) => x.id == item.definition).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.otherproperties?.hardware && hardwareData.find((x) => x.id == item.otherproperties.hardware) && hardwareData.find((x) => x.id == item.otherproperties.hardware).name.toLowerCase().includes(filterText.toLowerCase()))
  )
    ;



  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = [];

    exportarray = equipments.map((item) => {
      let iot = iotdata.find((x) => x.id == item.connectionproperties?.iotdevice);

      let equipmenttoexport = {};
      equipmenttoexport[equipmenttext.id] = item.id;
      equipmenttoexport[equipmenttext.name] = item.name;
      equipmenttoexport[equipmenttext.definition] = definitionData.find((x) => x.id == item.definition)?.name || '';
      equipmenttoexport[equipmenttext.hardware] = hardwareData.find((x) => x.id == item.otherproperties?.hardware)?.name || '';
      equipmenttoexport[equipmenttext.lastconnection] = (item.lastconnection && moment(item.lastconnection).isValid()) ? moment(item.lastconnection).format("DD/MM/YYYY HH:mm") : '';
      equipmenttoexport[equipmenttext.iot] = iot?.name || "N/A";
      equipmenttoexport[equipmenttext.iotbattery] = iot ? (iot?.status?.externalpowersource === 'true' ? 'AC' : iot.status?.deviceStatusbatterylevel ? (iot.status.deviceStatusbatterylevel + '%') : '') : 'N/A';
      equipmenttoexport[equipmenttext.iotsignal] = iot ? iot?.status?.margin ? (iot?.status?.margin + 'db') : '' : 'N/A';
      equipmenttoexport[equipmenttext.alarms] = alarmsdata?.find((al) => (al.equipment === item.id && al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ? 'Oui' : '';
      return equipmenttoexport;
    });
    return (
      <>
        <FilterDiv>
          <CustomSelect
            inputTitle={equipmentpagetext.displaymethod}
            selectValue={displaymethod}
            handleSelectValueChange={handleDisplaymethodChange}
            data={displaymethodData}
          />
        </FilterDiv>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {mbmadmin && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              {/* <AddMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <EditMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <DeleteMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={(!equipments || equipments.length < 1) && (!points || points.length < 1)} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, equipmentsdata, equipments, pointsdata, points, displaymethod, iotdata, alarmsdata]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItemsEquipments,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setEquipments,
    setPoints,
    pointsdata,
    equipmentsdata,
    displaymethod
  };
}
